import { css } from '@linaria/core';
import { theming, baseTheme } from 'styles/utils/core';
export const starContainer = "omponents__Star__Star_styles_ts-starContainer-s1icb6jj";
export const starCount = "omponents__Star__Star_styles_ts-starCount-s6cis82";
export const starBoxContainer = "omponents__Star__Star_styles_ts-starBoxContainer-s1cw6d2n";
export const starBoxCount = "omponents__Star__Star_styles_ts-starBoxCount-sujikz6";

require("./Star_styles.linaria.module.css!=!../../node_modules/@linaria/webpack-loader/node_modules/@linaria/webpack5-loader/lib/outputCssLoader.js!./Star_styles.ts");